import { render, staticRenderFns } from "./WeekendsView.vue?vue&type=template&id=40546226&"
import script from "./WeekendsView.vue?vue&type=script&lang=js&"
export * from "./WeekendsView.vue?vue&type=script&lang=js&"
import style0 from "./WeekendsView.vue?vue&type=style&index=0&id=40546226&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports